'use strict';

const urlJoin = require('url-join');
const { default: stipulate, resolveUrl } = require('stipulate');
const { baseOptions } = require('./configuration');
const config = require('../config');

const getProfile = (options, query) => {
  const { baseUrl } = config.get();

  let url = urlJoin(baseUrl, '/pb/users/from-cookie/');
  url = resolveUrl(url, query);

  return stipulate(url, baseOptions);
};

module.exports = {
  getProfile,
};
